import { SVGProps } from 'react'

export const StripeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_12699_78575)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.4587 16.1937C21.4587 14.5533 22.8267 13.9187 25.0371 13.9187C28.6954 13.9975 32.2852 14.9244 35.5227 16.626V6.72357C32.1844 5.41449 28.6238 4.76191 25.0371 4.80177C16.5171 4.80177 10.8027 9.25485 10.8027 16.6906C10.8027 28.3244 26.8131 26.4349 26.8131 31.4496C26.8131 33.4109 25.1331 34.0192 22.7691 34.0192C19.2831 34.0192 14.7807 32.5799 11.2491 30.6641V40.6958C14.8851 42.2744 18.8051 43.0982 22.7703 43.1169C31.5267 43.1169 37.5627 38.8003 37.5627 31.2352C37.5627 18.6795 21.4587 20.9222 21.4587 16.1961V16.1937Z"
        fill="#6772E5"
      />
    </g>
    <defs>
      <clipPath id="clip0_12699_78575">
        <rect
          width="38.4"
          height="38.3163"
          fill="white"
          transform="translate(4.79999 4.80029)"
        />
      </clipPath>
    </defs>
  </svg>
)
